/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DamageGroupFromJSON, DamageGroupToJSON, } from './';
export function CommonDamageKindDtoFromJSON(json) {
    return CommonDamageKindDtoFromJSONTyped(json, false);
}
export function CommonDamageKindDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'damageKindId': !exists(json, 'damageKindId') ? undefined : json['damageKindId'],
        'group': !exists(json, 'group') ? undefined : DamageGroupFromJSON(json['group']),
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
export function CommonDamageKindDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'damageKindId': value.damageKindId,
        'group': DamageGroupToJSON(value.group),
        'name': value.name,
    };
}
